import { FC } from 'react';

import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import { NeutralColors } from 'portfolio3/styles';
import { commonTheme } from 'portfolio3/styles/theme';
import { PercentDoughnut } from 'portfolio3/ui-kit';
import { SxStyles } from 'types';
import { getMarkPluralization, prettifyNumber } from 'utils';

const rootStyles: SxStyles = (theme) => ({
  display: 'flex',
  gap: '32px',

  [theme.breakpoints.down('commonSm')]: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

const doughnutStyles: SxStyles = (theme) => ({
  display: 'grid',
  placeItems: 'center',

  width: '90px',
  height: '90px',

  [theme.breakpoints.down('commonSm')]: {
    width: '58px',
    height: '58px',
  },
});

interface IDiagnosticCardResultShortProps {
  score: number;
  scorePercent: number;
  color: string;
}

const DiagnosticCardResultShort: FC<IDiagnosticCardResultShortProps> = ({ score, scorePercent, color }) => {
  const isSmallScreen = useMediaQuery(commonTheme.breakpoints.down('commonSm'));

  const prettyScorePercent = prettifyNumber(scorePercent, { precision: 1 });
  const pluralizedBall = getMarkPluralization(score);

  const doughnutElement = (
    <Box className="doughnut" sx={doughnutStyles}>
      <PercentDoughnut percent={scorePercent} color={color} />
      <Typography variant="Headings/H6" position="absolute">
        {prettyScorePercent}%
      </Typography>
    </Box>
  );

  const desktopDescriptionElement = (
    <Stack gap="8px">
      <Typography variant="Paragraph MD/Semi Bold" color={NeutralColors.light_neutrals_600} minWidth="max-content">
        Твой результат:
      </Typography>
      <Typography variant="Paragraph LG/Medium">
        {score} {pluralizedBall}
      </Typography>
    </Stack>
  );

  const mobileDescriptionElement = (
    <Typography variant="Paragraph LG/Medium">
      {score} {pluralizedBall}
    </Typography>
  );

  return (
    <Box className="diagnostic-card-result-short" sx={rootStyles}>
      {isSmallScreen ? mobileDescriptionElement : desktopDescriptionElement}
      {doughnutElement}
    </Box>
  );
};

export default DiagnosticCardResultShort;
